import { useDynamicModalContext } from "@umami/components";

import { BaseBackButton } from "./BaseBackButton";
type ModalBackButtonProps = {
  onBack?: () => void;
  payload?: Record<string, any>;
};
export const ModalBackButton = ({ onBack, payload }: ModalBackButtonProps) => {
  const handleGoBack = () => {
    if (onBack) {
      onBack();
    }
    goBack(payload);
  };
  const { hasPrevious, goBack } = useDynamicModalContext();

  return hasPrevious ? <BaseBackButton onClick={handleGoBack} /> : null;
};
